import { Injectable } from '@angular/core';
import { DashboardState } from './dashboard.state';
import { Store } from 'rxjs-observable-store';
import { UserCertificationService } from '@services/user-certification.service';
import { map } from 'rxjs/operators';
import { CertificationStatus } from '@models/certification-status';
import { CommunicationService } from '@services/communication.service';
import { AuthService } from '@services/auth.service';
import { UserTestService } from '@services/user-test.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardStore extends Store<DashboardState> {
  constructor(
    private userCertificationService: UserCertificationService,
    private communicationService: CommunicationService,
    private userTestService: UserTestService,
    private authService: AuthService
  ) {
    super({
      userCertifications: [],
      communications: [],
      sampleTests: []
    });
  }

  init() {
    this.userCertificationService.getCerts().subscribe(certs => {
      this.setState({
        ...this.state,
        userCertifications: certs
      });
    });

    this.userTestService.getSampleTests().subscribe(tests => {
      this.setState({
        ...this.state,
        sampleTests: tests
      });
    });

    this.communicationService.showUnreadCommunications();
  }

  public get inactiveCertifications$() {
    return this.filterCerts(CertificationStatus.Inactive);
  }

  public get activeCertifications$() {
    return this.filterCerts(CertificationStatus.Active);
  }

  public get pendingCertifications$() {
    return this.filterCerts(CertificationStatus.Pending);
  }

  public get completedCertifications$() {
    return this.filterCerts(CertificationStatus.Completed);
  }

  public get expiredCertifications$() {
    return this.filterCerts(CertificationStatus.Expired);
  }

  public get sampleTests$() {
    return this.state$.pipe(map(state => state.sampleTests));
  }

  private filterCerts(by: CertificationStatus) {
    return this.state$.pipe(map(state => state.userCertifications.filter(cert => cert.status === by)));
  }
}
